import { Box, Container, Heading, Legal, LegalList } from '@dapperlabs/core-fe';
import React from 'react';

export interface TermsContentProps {
  sections: Array<Legal>;
  title: string;
}

export const TermsContent = ({ title, sections }: TermsContentProps) => {
  return (
    <Container
      maxWidth={{ lg: '90%', sm: '100%' }}
      paddingTop={10}
      px={{ lg: '5%', sm: 2 }}
    >
      <Heading
        mb={['1rem', null, '1.5rem']}
        px='6'
        fontFamily='poster'
        fontSize='4.375rem'
        fontWeight='400'
      >
        {title}
      </Heading>
      <Box pb={4} px={2}>
        <LegalList legalList={sections} />
      </Box>
    </Container>
  );
};
